module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple_pay_logo-ffa85a4b.svg";